import { ExperimentsService } from '../app/shared/services/experiments/experiments.service';
import { Routes } from '@angular/router';
import { Chapter, PagePath } from '../app/shared/models/page-model';
import { CanActivateQuestionaireGuard } from '../app/shared/services/guards/can-activate-questionaire.guard';
import { CanActivatePostCoQxGuard } from '../app/shared/services/guards/can-activate-post-co-qx.guard';

const classicRoutes: Routes = [
  {
    path: '',
    pathMatch: 'full',
    redirectTo: Chapter.Name + '/' + PagePath.BusinessState,
  },
  {
    path: '',
    canActivate: [CanActivateQuestionaireGuard],
    children: [
      {
        path: Chapter.Name,
        loadChildren: () =>
          import('./modules/name-desktop.module').then(
            (m) => m.NameDesktopModule
          ),
      },
      {
        path: Chapter.Business,
        loadChildren: () =>
          import('./modules/business-desktop.module').then(
            (m) => m.BusinessDesktopModule
          ),
      },
      {
        path: Chapter.Services,
        loadChildren: () =>
          import('./modules/included-desktop.module').then(
            (m) => m.IncludedDesktopModule
          ),
        data: { preload: true, delay: 2 },
      },
      {
        path: Chapter.Essentials,
        loadChildren: () =>
          import('./modules/essentials-desktop.module').then(
            (m) => m.EssentialsDesktopModule
          ),
        data: { preload: true, delay: 4 },
      },
      {
        path: Chapter.Package,
        loadChildren: () =>
          import('./modules/package-desktop.module').then(
            (m) => m.PackageDesktopModule
          ),
        data: { preload: true, delay: 6 },
      },
      {
        path: Chapter.Checkout,
        loadChildren: () =>
          import('./modules/checkout-desktop.module').then(
            (m) => m.CheckoutDesktopModule
          ),
        data: { preload: true, delay: 8 },
      },
      {
        path: Chapter.PostOrder,
        canActivate: [CanActivatePostCoQxGuard],
        // canActivateChild: [CheckoutBackButtonGuard], // TODO check the logic and apply this guard again
        loadChildren: () =>
          import('./modules/post-checkout.module').then(
            (m) => m.PostCheckoutModule
          ),
        data: { preload: true, delay: 10 },
      },
    ],
  },
  { path: '**', redirectTo: Chapter.Name + '/' + PagePath.ChangeName },
];

const gloRoutes: Routes = [
  {
    path: '',
    pathMatch: 'full',
    redirectTo: Chapter.Name + '/' + PagePath.BusinessState,
  },
  {
    path: '',
    canActivate: [CanActivateQuestionaireGuard],
    children: [
      {
        path: Chapter.Name,
        loadChildren: () =>
          import(
            './pl-features/glo-design/modules/glo-name-desktop.module'
          ).then((m) => m.GloNameDesktopModule),
        data: { theme: 'glo' },
      },
      {
        path: Chapter.Business,
        loadChildren: () =>
          import(
            './pl-features/glo-design/modules/glo-business-desktop.module'
          ).then((m) => m.GloBusinessDesktopModule),
        data: { theme: 'glo' },
      },
      {
        path: Chapter.Services,
        loadChildren: () =>
          import(
            './pl-features/glo-design/modules/glo-included-desktop.module'
          ).then((m) => m.GloIncludedDesktopModule),
        data: { preload: true, delay: 2, theme: 'glo' },
      },
      {
        path: Chapter.Essentials,
        loadChildren: () =>
          import(
            './pl-features/glo-design/modules/glo-essentials-desktop.module'
          ).then((m) => m.GloEssentialsDesktopModule),
        data: { preload: true, delay: 4, theme: 'glo' },
      },
      {
        path: Chapter.Package,
        loadChildren: () =>
          import(
            './pl-features/glo-design/modules/glo-package-desktop.module'
          ).then((m) => m.GloPackageDesktopModule),
        data: { preload: true, delay: 6, theme: 'glo' },
      },
      {
        path: Chapter.Checkout,
        loadChildren: () =>
          import(
            './pl-features/glo-design/modules/glo-checkout-desktop.module'
          ).then((m) => m.GloCheckoutDesktopModule),
        data: { preload: true, delay: 8, theme: 'glo' },
      },
      {
        path: Chapter.PostOrder,
        canActivate: [CanActivatePostCoQxGuard],
        // canActivateChild: [CheckoutBackButtonGuard], // TODO check the logic and apply this guard again
        loadChildren: () =>
          import(
            './pl-features/glo-design/modules/glo-post-checkout.module'
          ).then((m) => m.GloPostCheckoutModule),
        data: { preload: true, delay: 10 },
      },
    ],
  },
  { path: '**', redirectTo: Chapter.Name + '/' + PagePath.ChangeName },
];

export const routeFactory = (experimentsService: ExperimentsService) =>
  experimentsService.getGloDesignTest() ? gloRoutes : classicRoutes;
